<div class="d-flex" style="height: 100%; flex-flow: column;">
	<div style="flex-grow: 1; overflow: auto;">
		<div class="card inner-shadow">
			<div class="card-body">
				<app-task-form #taskForm [task]="taskObj" (onSubmit)="onFormSubmit($event)"
					(validForm)="formValid = $event;"></app-task-form>
			</div>
		</div>
	</div>
	<div class="d-flex mt-2" style="justify-content: space-between;">
		<!-- <div (click)="back()" class="btn mb-0 btn-sm btn-secondary"> -->
		<div backButton class="btn mb-0 btn-sm btn-secondary">
			{{'Cancel' | translate}}
		</div>
		<button type="submit" (click)="taskForm.onFormSubmit()" [disabled]="!formValid" class="btn mb-0 btn-sm btn-primary">
			{{'Save' | translate}}
		</button>
	</div>
</div>